<script>
  import resources from './resources'
  export default {
    name: 'overview',
    mixins: [resources]
  }
</script>

<template lang="pug">
  div
    .body.m-b-20.bg-deep-purple(v-for="all in alls")
      .event-name.row
        .col-3.text-center
          h4
            | {{ dtDay(all.start_date) }}
            span {{ dtMonth(all.start_date) }}
            span {{ dtYear(all.start_date)}}
        .col-9
          h6 {{ all.event_name }}
          p {{ all.title }}
          address
            i.zmdi.zmdi-pin
            |  {{ all.area.name }}
</template>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/forall/all.vue